import httpClient from './httpClient';

/**
 * Serviço para consumir os endpoints de status de atividade. Este serviço
 * contém funções para listar, criar, atualizar e excluir registros de
 * StatusAtividade. As funções que modificam dados devem ser
 * utilizadas apenas por usuários com cargo de administrador, pois o
 * backend valida as permissões.
 */

/**
 * Lista todos os status de atividades cadastrados. Qualquer usuário
 * autenticado pode consultar.
 *
 * @returns {Promise<Array>} Array com objetos { id, nome, cor }
 */
export async function listarStatusAtividades() {
  const resp = await httpClient.get('/api/status-atividades');
  return Array.isArray(resp.data) ? resp.data : [];
}

/**
 * Cria um novo status de atividade. Somente admins podem realizar
 * esta operação; caso contrário, o backend retornará erro 403.
 *
 * @param {object} status objeto contendo { nome, cor }
 * @returns {Promise<object>} status criado
 */
export async function criarStatusAtividade(status) {
  const resp = await httpClient.post('/api/status-atividades', status);
  return resp.data;
}

/**
 * Atualiza um status de atividade existente. Somente admins podem
 * realizar esta operação.
 *
 * @param {number|string} id identificador do status
 * @param {object} status objeto com campos a serem atualizados
 * @returns {Promise<object>} status atualizado
 */
export async function atualizarStatusAtividade(id, status) {
  const resp = await httpClient.put(`/api/status-atividades/${id}`, status);
  return resp.data;
}

/**
 * Remove um status de atividade. Somente admins podem realizar esta
 * operação.
 *
 * @param {number|string} id identificador do status
 */
export async function removerStatusAtividade(id) {
  await httpClient.delete(`/api/status-atividades/${id}`);
}
